/**
 * Typed access to Vite-injected env vars.
 * Centralized so we fail loudly if a required variable is missing.
 */

interface RuntimeEnv {
  readonly apiBaseUrl: string;
  readonly frontendOrigin: string;
  readonly googleOAuthClientId: string;
  readonly linkedinOAuthClientId: string;
  readonly enableQueryDevtools: boolean;
  readonly sentryDsn: string;
  readonly isDev: boolean;
  readonly isProd: boolean;
}

function read(key: string, fallback = ''): string {
  const value = (import.meta.env as Record<string, string | undefined>)[key];
  return (value ?? fallback).trim();
}

export const env: RuntimeEnv = {
  apiBaseUrl: read('VITE_API_BASE_URL', 'http://localhost:8000').replace(/\/$/, ''),
  frontendOrigin: read('VITE_FRONTEND_ORIGIN', window.location.origin),
  googleOAuthClientId: read('VITE_GOOGLE_OAUTH_CLIENT_ID'),
  linkedinOAuthClientId: read('VITE_LINKEDIN_OAUTH_CLIENT_ID'),
  enableQueryDevtools: read('VITE_ENABLE_QUERY_DEVTOOLS') === '1',
  sentryDsn: read('VITE_SENTRY_DSN'),
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
};
